"use client";
import { MangoBlockProps } from "@/types/general";
import { useRelatedPosts } from "@pulsex/hooks";
import BasicGrid from "../shared/Grids/BasicGrid";
import pulseConfig from "@/pulsex.config";

export default function ElasticRelatedGrid({
    block,
    pagePostId,
    ...rest
}: MangoBlockProps) {
    let widget;
    if (block) widget = block.getMainWidget();
    else widget = (rest as any)?.widget;

    const toDate = new Date();
    const { posts, isLoading } = useRelatedPosts({
        config: pulseConfig,
        postId: pagePostId,
        size: 4,
        toDate: toDate.toISOString(),
    });

    if (!widget) return null;

    if (isLoading) return "loading...";
    if (!posts?.length) return null;
    return (
        <BasicGrid
            title={widget?.title}
            posts={posts}
            titleClassName={"text-xl"}
            {...rest}
        />
    );
}
